import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["totalAuthorizedAmount"]

  updateTotal(newTotal) {
    if (this.hasTotalAuthorizedAmountTarget) {
      // Format the currency display
      const formattedTotal = `$${parseFloat(newTotal).toFixed(2)}`
      this.totalAuthorizedAmountTarget.textContent = formattedTotal
    }
  }
}